import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  useEffect(() => {
    document.title = 'Page not found | LRG Holdings';
    let m = document.head.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement('meta'); m.setAttribute('name', 'robots'); document.head.appendChild(m); }
    m.setAttribute('content', 'noindex');
    return () => m.setAttribute('content', 'index, follow, max-image-preview:large');
  }, []);

  return (
    <section className="bg-[#071627] min-h-[70vh] flex items-center" data-testid="not-found">
      <div className="container-lg pt-24">
        <p className="eyebrow eyebrow-line eyebrow-light mb-6">404</p>
        <h1 className="font-serif text-[#f7f4ee] text-4xl md:text-6xl leading-[1.05]">This page could not be found.</h1>
        <Link to="/" className="btn-gold mt-10">Return Home</Link>
      </div>
    </section>
  );
};

export default NotFound;
